import { render, staticRenderFns } from "./v-offer.vue?vue&type=template&id=0229f1d4"
import script from "./v-offer.vue?vue&type=script&lang=js"
export * from "./v-offer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports